// import React, {useState, useEffect} from 'react';

// const SVG = ({name, width, height}) => {
//   const [loaded, setLoaded] = useState(false);
//   const [src, setSrc] = useState(null);

//   useEffect(() => {
//     const imageSrc = require(`../../../../assets/svg/${name}.svg`);
//     setSrc(imageSrc);
//   }, [name]);

//   if (!src) return null;

//   return (
//     <div style={{width, height, position: 'relative'}}>
//       {!loaded && (
//         <div
//           style={{
//             width,
//             height,
//             backgroundColor: '#eee',
//             position: 'absolute',
//             top: 0,
//             left: 0,
//           }}
//         />
//       )}
//       <img
//         src={src}
//         style={{width, height, display: loaded ? 'block' : 'none'}}
//         onLoad={() => setLoaded(true)}
//         alt={name}
//       />
//     </div>
//   );
// };

// export default SVG;
import React from 'react';
import { svgs } from '../../../../utils/iconList';

const SVG = ({ name, width, height, color, style }) => {
  const SvgComponent = svgs[name];

  if (!SvgComponent) {
    console.error('SVG not found in iconList:', name);
    return (
      <div
        style={{
          width: width,
          height: height,
          backgroundColor: '#f0f0f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px dashed #ccc',
          borderRadius: '4px',
          ...style,
        }}
      >
        <span style={{ fontSize: '12px', color: '#666' }}>SVG Error: {name}</span>
      </div>
    );
  }

  // مسیر فایل SVG را به صورت داینامیک بارگذاری می‌کنیم
  const svgPath = require(`../../../../assets/svg/${name}.svg`);

  return (
    <object
      type="image/svg+xml"
      data={svgPath}  // مسیر فایل SVG
      width={width}   // عرض
      height={height} // ارتفاع
      style={{
        width: width,
        height: height,
        objectFit: 'contain', // برای حفظ نسبت ابعادی تصویر
        imageRendering: 'optimizeQuality', // برای بهبود کیفیت رندر
        ...style,             // سایر استایل‌ها
      }}
    >
      {/* در صورتی که SVG نتواست بارگذاری بشه */}
      <span>SVG not supported or failed to load</span>
    </object>
  );
};

export default SVG;

